import { render, staticRenderFns } from "./Inicio.vue?vue&type=template&id=fe42d464&scoped=true"
import script from "./Inicio.vue?vue&type=script&lang=js"
export * from "./Inicio.vue?vue&type=script&lang=js"
import style0 from "./Inicio.vue?vue&type=style&index=0&id=fe42d464&prod&lang=scss"
import style1 from "./Inicio.vue?vue&type=style&index=1&id=fe42d464&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe42d464",
  null
  
)

export default component.exports